export default __webpack_public_path__ + "static/media/userIcon.98383346.svg";